var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Skill } from '@/models/Skill';
import { SkillCategory } from '@/models/SkillCategory';
let CreateSkillDialog = class CreateSkillDialog extends Vue {
    constructor() {
        super(...arguments);
        this.name = '';
        this.newName = '';
        this.formValid = false;
        this.nameRules = [(v) => !!v || 'Name is required'];
    }
    mounted() {
        //
    }
    async createSkillSet() {
        if (!this.skillCategory) {
            return;
        }
        try {
            await new Skill().create({
                name: this.name,
                category: this.skillCategory.id,
            });
            this.$emit('onCreated');
        }
        catch (error) {
            //
        }
    }
    deleteSkill() {
        this.$emit('deleteSkill');
    }
    closeDialog() {
        this.$emit('input', false);
    }
};
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof SkillCategory !== "undefined" && SkillCategory) === "function" ? _a : Object)
], CreateSkillDialog.prototype, "skillCategory", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Array)
], CreateSkillDialog.prototype, "users", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], CreateSkillDialog.prototype, "isConfirmingDelete", void 0);
CreateSkillDialog = __decorate([
    Component({
        components: {
        //
        },
    })
], CreateSkillDialog);
export default CreateSkillDialog;
